module.exports = __webpack_public_path__ + "img/monterey_auto_tilt.594dad27.png";